import React from 'react';
import { FiPlus, FiTrash2 } from 'react-icons/fi';
import { PRODUCT_FEATURE_ICONS } from '../components/ProductPage/productFeatureIcons';

export default function ProductFeaturesEditor({ features, onChange }) {
  const addFeature = () => {
    if (features.length < 12) onChange([...features, { icon: 'settings', label: '' }]);
  };

  const updateFeature = (index, field, value) => {
    onChange(features.map((feature, featureIndex) => (
      featureIndex === index ? { ...feature, [field]: value } : feature
    )));
  };

  const removeFeature = (index) => {
    onChange(features.filter((_, featureIndex) => featureIndex !== index));
  };

  return (
    <div className="va-feature-editor">
      {features.map((feature, index) => {
        const selectedIcon = PRODUCT_FEATURE_ICONS.find(({ value }) => value === feature.icon);
        const PreviewIcon = selectedIcon?.Icon;
        return (
          <div className="va-feature-row" key={`${index}-${feature.icon}`}>
            <span className="va-feature-preview" aria-hidden="true">{PreviewIcon && <PreviewIcon />}</span>
            <div className="va-field">
              <label htmlFor={`feature-icon-${index}`}>Symbol</label>
              <select id={`feature-icon-${index}`} className="va-input" value={feature.icon} onChange={(event) => updateFeature(index, 'icon', event.target.value)}>
                {PRODUCT_FEATURE_ICONS.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}
              </select>
            </div>
            <div className="va-field va-feature-label-field">
              <label htmlFor={`feature-label-${index}`}>Function text</label>
              <input id={`feature-label-${index}`} className="va-input" value={feature.label} maxLength={100} placeholder="e.g. IP65 protection level" onChange={(event) => updateFeature(index, 'label', event.target.value)} required />
            </div>
            <button className="va-button va-button--danger va-button--icon" type="button" onClick={() => removeFeature(index)} aria-label={`Remove function ${index + 1}`}><FiTrash2 /></button>
          </div>
        );
      })}
      <button className="va-button va-button--secondary" type="button" onClick={addFeature} disabled={features.length >= 12}><FiPlus /> Add function</button>
      <small>Optional. Add up to 12 functions; this section will only appear on the public page when functions are configured.</small>
    </div>
  );
}
